<template>
  <router-view />
</template>

<script>
export default {
  mounted() {
    this.$store.commit('adminPanel/setViewTitle', {
      depth: 0,
      title: 'Group Management',
      to: { name: 'sectors' },
      last: false,
    });
  },
};
</script>

<style></style>
